import classNames from 'classnames';

export default function Input(props: {
    type?: string, // text, search, email, ..
    color?: string, // danger, success, warning
    size?: string, // small, medium, normal
    fullwidth?: boolean,
    disabled?: boolean,
    className?: string,
    value?: string | number,
    step?:number,
    onClick?: () => void
    onChange?: (value: any) => void,
}) {
    let {
        type = 'text',
        color = '',
        size = '',
        fullwidth = false,
        disabled = false,
        className = '',
        step=1,
        onChange,
        ...properties
    } = props;

    const classes = classNames('input', {
        'is-fullwidth': fullwidth,
        [`is-${color}`]: color.length,
        [`is-${size}`]: size.length,
        [className]: className.length
    });

    const handleChange = (e: any) => {
        
        if (onChange) {
            onChange(e); 
        }
    };

    return (
        <input
            className={classes}
            type={type}
            step={step}
            disabled={disabled}
            onChange={handleChange}
            {...properties}
        />
    );
}
